// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-wrapper:before{content:\" \";display:inline-block;height:100%;vertical-align:middle}.logo-wrapper{height:62px;text-align:center;width:200px}.logo-wrapper img{max-height:80%;max-width:70%}", ""]);
// Exports
module.exports = exports;
